var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99998V0.5H7.49998V7.99998H0ZM0 17.5V9.99998H7.49998V17.5H0ZM9.49998 7.99998V0.5H17V7.99998H9.49998ZM9.49998 17.5V9.99998H17V17.5H9.49998ZM1.49997 6.5H6V1.99998H1.49997V6.5ZM11 6.5H15.5V1.99998H11V6.5ZM11 16H15.5V11.5H11V16ZM1.49997 16H6V11.5H1.49997V16Z",
    fill: "#2E3336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.b486fde22aa3a44f0764e096456a933f.svg";
export { ForwardRef as ReactComponent };